import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import HorizontalFormInput from '../../../../../../../../components/FormHelpers/horizontalFormInput';
import PrefillDropdown from './components/PrefillDropdown';

const Message = ({ loadDeliveryMessage }) => {
  const { control } = useFormContext();

  return (
    <div className="card">
      <div className="card-header">
        <span className="card-header__title">Leveransmeddelande till mottagare</span>
      </div>

      <div className="card__body form">
        <HorizontalFormInput
          name="deliveryMessage"
          control={control}
          renderAs="textarea"
          className="form-control"
          label="Meddelande"
          rows={4}
          maxlength={2000}
        />

        <Controller
          name="sendWithoutTemplate"
          control={control}
          defaultValue={false}
          render={({ field }) => (
            <div>
              <input
                {...field}
                type="checkbox"
                id="sendWithoutTemplate"
                checked={field.value}
                onChange={(e) => field.onChange(e.target.checked)}
              />
              {' '}
              <label htmlFor="sendWithoutTemplate">
                Skicka mail obrandat (helt vitt, enbart text)
              </label>
            </div>
          )}
        />

        <PrefillDropdown loadDeliveryMessage={loadDeliveryMessage} />
      </div>

      {/* <div className="card__footer card__footer--right">
        <button className="btn" type="button">Förhandsgranska brev</button>
      </div> */}
    </div>
  );
};

export default Message;